import { useState } from "react";
import "../../assets/css/Pagination.css";
// import Assets from "../../Assets/Assets";
import Assets from '../../assets/assets'

const Pagination = ({ totalPages, currentPage = 1, onPageChange }) => {
  const [page, setPage] = useState(currentPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setPage(pageNumber);
      onPageChange(pageNumber);
    }
  };

  const renderPages = () => {
    const pages = [];

    // Always include Page 1
    pages.push(1);

    // If totalPages is 1 or 2, show all pages
    if (totalPages <= 2) {
      for (let i = 2; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Add pages dynamically based on current page
      if (page <= 3) {
        for (let i = 2; i <= 3; i++) {
          pages.push(i);
        }
        if (totalPages > 4) pages.push("...");
        pages.push(totalPages);
      } else if (page >= totalPages - 2) {
        pages.push("...");
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push("...");
        pages.push(page - 1);
        pages.push(page);
        pages.push(page + 1);
        pages.push("...");
        pages.push(totalPages);
      }
    }

    return pages;
  };

  return (
    <div className="pagination-container">
      <div className="pagination">
        {page === 1 ? (
          <img
            src={Assets.InactiveLeft}
            alt="prev"
            onClick={() => handlePageChange(page - 1)}
            className="inactive-arrow"
          />
        ) : (
          <img
            src={Assets.ActiveRight}
            alt="prev"
            onClick={() => handlePageChange(page - 1)}
            className="active-arrow rotate"
          />
        )}
        {renderPages().map((pg, index) =>
          pg === "..." ? (
            <span key={index} className="ellipsis">
              ...
            </span>
          ) : (
            <button
              key={index}
              onClick={() => handlePageChange(pg)}
              className={`page-button ${
                pg === page ? "current-page" : "normal-page"
              }`}
            >
              {pg}
            </button>
          )
        )}
        {page === totalPages ? (
          <img
            src={Assets.InactiveLeft}
            alt="nxt"
            onClick={() => handlePageChange(page + 1)}
            className="inactive-arrow rotate"
          />
        ) : (
          <img
            src={Assets.ActiveRight}
            alt="nxt"
            onClick={() => handlePageChange(page + 1)}
            className="active-arrow"
          />
        )}
      </div>
    </div>
  );
};

export default Pagination;
